import { TemplatesFactory } from '@domains/subscription'
import { createRoute } from '@domains/subscription/router/router'
import { useNavigate } from 'react-router-dom'

export const SubscriptionPage = () => {
  const navigate = useNavigate()

  const onNavigateToTemplate = (templateId: string): void => {
    navigate(createRoute.templateDetailsTab({ templateId, tab: 'features' }))
  }

  const onNavigateToDefaultConfig = (configId: string): void => {
    navigate(createRoute.configDetails({ configId }))
  }

  return <TemplatesFactory navigateToTemplate={onNavigateToTemplate} navigateToDefaultConfig={onNavigateToDefaultConfig} />
}
